import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { FacultyItem } from '@tcaster/tcaster-web-lib';

import GridList from '../../Components/SearchableGridList';

export default class FacultyList extends Component {
  static propTypes = {
    data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        avatarImage: PropTypes.string,
      }),
    ),
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: () => {},
  };

  constructor(props) {
    super(props);
  }

  handleClick = (id, index, data) => {
    // console.log('FacultyList handleClick:', id, index, data);
    this.props.onClick(id, data);
  };

  renderItem = (data, index) => {
    return <FacultyItem {...data} image={data.avatarImage} onClick={() => {}} />;
  };

  render() {
    const { data, renderHeader } = this.props;
    return (
      <GridList
        data={data}
        renderItem={this.renderItem}
        onClick={this.handleClick}
        searchPlaceholderText="ใส่ชื่อคณะ..."
        as="div"
        renderHeader={renderHeader}
      />
    );
  }
}
